module.exports = __webpack_public_path__ + "static/media/caution.b563208d.png";